import * as React from "react";

import { NavMain } from "@/components/nav-main";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import {
  Banknote,
  ChartArea,
  Gem,
  LayoutDashboard,
  UserCircleIcon,
  WalletCards,
} from "lucide-react";
import { useProfile } from "@/context/ProfileProvider";
import logo from "../assets/logo.png";
export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { profile }: any = useProfile();
  const data = {
    user: {
      name: profile?.first_name || "" + " " + profile?.last_name || "",
      email: profile?.email || "",
    },
    navMain: [
      {
        title: "Dashboard",
        url: "/dashboard",
        icon: <LayoutDashboard />,
      },
      {
        title: "Cuentas",
        url: "/accounts",
        icon: <WalletCards />,
      },
      {
        title: "Balance",
        url: "/balance",
        icon: <Banknote />,
      },
      {
        title: "Reportes",
        url: "/report",
        icon: <ChartArea />,
      },
      {
        title: "Perfil",
        url: "/profile",
        icon: <UserCircleIcon />,
      },
      {
        title: "Planes",
        url: "/pricing",
        icon: <Gem />,
      },
      // {
      //   title: "Comparativas",
      //   url: "/invest",
      //   icon: <Landmark />,
      // },
    ],
  };

  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:!p-1.5"
            >
              <a href="/">
                <span className="  font-semibold flex items-center">
                  <img width={30} src={logo} className="mr-3"></img>Finanza.lat
                </span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
        <div className="px-2 py-2"></div>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={data.user} />
      </SidebarFooter>
    </Sidebar>
  );
}
